// extracted by mini-css-extract-plugin
export default {"about":"AboutSection_about__O0hX2","content":"AboutSection_content__BQl4n","avatar":"AboutSection_avatar__kDUKt"};